import React, { ReactNode } from "react";
import { Icon } from "../icon";

interface UserManualProps {
  title: string;
  icon: ReactNode;
  guideLink: string;
}

export const UserManual = ({
  title = "",
  icon = <Icon.DeleteBin5Line />,
  guideLink = "",
}: Partial<UserManualProps>) => {
  return (
    <div
      className="text-md-left font-weight-normal p-3 bg-info text-white"
      style={{ fontSize: "14px" }}
    >
      <div className="row title__process-container">
        <div className="">
          <span className="icon__title-process">{icon}</span>
          {title}
        </div>
        <div className="See-User-Manual">
          <span className="icon__User-Manual">
            <Icon.ArrowRight />
          </span>
          <a href={guideLink} target="_blank" rel="noreferrer">
            Xem hướng dẫn sử dụng
          </a>
        </div>
      </div>
    </div>
  );
};
